// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7zmv5","gray":"styles_gray__G9RUG","blue":"styles_blue__3tgvy","blueBlock":"styles_blueBlock__2CVZj","disabledLink":"styles_disabledLink__CLX1P"};